<template>
  <div class="home">
    <!-- 限定最大宽度的内容主容器 -->
    <div class="home-container">

      <!-- 头部超级轮播图（收束为主宽并增加卡片圆角） -->
      <div class="carousel-wrapper">
        <el-carousel indicator-position="outside" class="hero-carousel">
          <el-carousel-item v-for="item in images" :key="item.id">
            <img :src="resolveUrl(item.url)" class="hero-img">
          </el-carousel-item>
        </el-carousel>
      </div>
      
      <!-- 快捷入口与客户展示 -->
      <div class="mid-section section-card"> 
        <div class="mid-contact">
          <div style="cursor: pointer; width: 100%;" @click="$router.push('/contact').catch(()=>{})">
            <img src="../assets/homePub/zixun.gif" class="contact-banner" /> 
          </div>   
        </div>
        <div class="mid-customers">
          <el-carousel :interval="4000" type="card" height="150px" class="customers-carousel">
            <el-carousel-item v-for="item in customers" :key="item.id">
              <img :src="resolveUrl(item.url)" class="customer-img">
              <div class="customer-name-bar"> 
                <span class="customer-name">{{item.name}}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 新增：公司宣传与核心优势 -->
      <div class="features-section section-card">
        <h3 class="features-title">我们的核心优势</h3>
        <p class="features-subtitle">专注企业制服定制，以匠心铸就品牌实力</p>
        <div class="features-grid">
          <div class="feature-item">
            <i class="el-icon-medal-1 feature-icon"></i>
            <h4 class="feature-name">专业定制</h4>
            <p class="feature-desc">结合企业文化与行业特征，提供独树一帜的专属制服设计方案。</p>
          </div>
          <div class="feature-item">
            <i class="el-icon-trophy feature-icon"></i>
            <h4 class="feature-name">严选面料</h4>
            <p class="feature-desc">精选优质耐磨、舒适透气的国内外高端面料，保证穿着体验。</p>
          </div>
          <div class="feature-item">
            <i class="el-icon-magic-stick feature-icon"></i>
            <h4 class="feature-name">匠心工艺</h4>
            <p class="feature-desc">引进国际先进设备和高精度量体裁衣技术，确保做工精良无瑕疵。</p>
          </div>
          <div class="feature-item">
            <i class="el-icon-service feature-icon"></i>
            <h4 class="feature-name">尊享服务</h4>
            <p class="feature-desc">提供全套量身定制、快速响应的售前售后闭环，以客户满意为生命。</p>
          </div>
        </div>
      </div>

      <!-- 主体详情区 -->
      <div class="details-section">  
        
        <!-- 广告横幅与组件模块 -->
        <div class="section-card ad-nav-box">
          <img src="../assets/head/advertising.jpg" class="ad-img" />
          <NavCloth class="nav-cloth"></NavCloth>
        </div>
        
        <!-- 主展示图墙 -->
        <div class="photo-wall-row">
          <img src="../assets/homePub/10.jpg" alt="" /> 
          <img src="../assets/homePub/3.jpg" alt="" />
        </div>
        <div class="photo-wall-row">
          <img src="../assets/homePub/1.jpg" alt="" /> 
          <img src="../assets/homePub/2.jpg" alt="" />    
        </div>
        
        <!-- 资讯新闻和公司简介 -->
        <div class="info-section">
          <!-- 左侧：新闻资讯 -->
          <div class="info-left section-card">
            <h4 class="section-title">新闻资讯</h4>
            <el-divider><i class="el-icon-star-on"></i></el-divider>
            <img src="../assets/homePub/news.jpg" class="news-banner" alt="" /> 
            
            <ul class="news-list">
              <li class="news-item" v-for="item in articles" :key="item.id">
                <router-link :to="'/article/' + item.id" class="news-link">
                  <span class="news-title">{{ item.title }}</span>
                  <span class="news-date">{{ item.date }}</span>
                </router-link>
              </li>
            </ul>
          </div>
          
          <!-- 右侧：公司简介 -->
          <div class="info-right section-card">
            <h4 class="section-title">公司简介</h4>
            <el-divider><i class="el-icon-star-on"></i></el-divider>
            <img src="../assets/homePub/aboutus_bg_1.jpg" class="about-banner" alt="" /> 
            <el-divider></el-divider>
            <div class="about-desc">
              泉州三辰服饰有限公司是一家致力于品牌制服创意设计，生产销售的专业制服公司。主要制服包括：酒店、宾馆、商场、工厂、学校等企事业机关制作团体制服。主要生产的产品有高档西装、衬衣、文化衫、T恤衫、太阳帽及特种制服（防火服、静电服）等服饰系列。<br><br>
              公司自成立以来，倡导企业新文化、新理念、新模式、新天地，并以现代科技手段促中国制服振兴为目标，引进现代营销理念和管理模式。同时积极借鉴欧洲现代企业制服的新概念，融入美国﹑日本﹑韩国等企业制服的发展流行趋势。综合我国各行各业的特征，完善进取，采用精工细做的专业设计，不断为满足客户各方面需要。
            </div>
            <el-divider></el-divider>
            <div class="about-thumbs">
              <img src="../assets/homePub/t1.jpg" alt="" />     
              <img src="../assets/homePub/t2.jpg" alt="" />     
              <img src="../assets/homePub/t3.jpg" alt="" />     
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import NavCloth from '../components/NavCloth.vue'
import { getHomeImages, getCustomers } from "@/api/home"

export default {
  name: 'HomeView',
  components: {
    NavCloth
  },
  data() {
    return {
      images: [],
      customers: [],
      articles: [
        { id: 1, title: '不同行业如何让选择工作服', date: '2021-07-29' },
        { id: 2, title: '工服定做厂家：定做工作服需要注意哪些设计要点？', date: '2021-09-16' },
        { id: 3, title: '工服定做厂家：工服定做应该遵循哪些原则？', date: '2021-08-18' },
        { id: 4, title: '短袖工作服选择什么面料比较好？', date: '2021-08-03' },
        { id: 5, title: '合格的阻燃防护服如何选择？', date: '2021-06-25' },
        { id: 6, title: '不同面料夏季工作服的保养方法', date: '2021-06-08' },
        { id: 7, title: '工服定做厂家：吸湿排汗工作服的原料和工艺', date: '2021-05-12' },
        { id: 8, title: '工作服厂家：如何判断工作服的质量', date: '2021-05-10' },
        { id: 9, title: '吸湿排汗工作服的原理和性能特点', date: '2021-04-27' },
        { id: 10, title: '工作服厂家:日常清洁工作服的提示', date: '2021-04-14' }
      ]
    }
  },  
  computed: {
    apiBase() {
      return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8081'
    },
  },
  methods: {
    resolveUrl(u) {
      if (!u) return ''
      if (/^https?:\/\//i.test(u)) return u
      const base = (this.apiBase || '').replace(/\/$/, '')
      const path = String(u).trim().replace(/\\/g, '/').replace(/^\/+/, '')
      return `${base}/${path}`
    },
    async load() {
      try {              
        const res = await getHomeImages()
        const res2 = await getCustomers()
        this.images = res.data || []
        this.customers = res2.data || []
      } catch (err) {
        console.log(err)
      }
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style scoped>
/* 核心容器约束 */
.home {
  background-color: #f7f9fa;
  min-height: 100vh;
  padding-bottom: 40px;
}
.home-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 统一卡片风格 */
.section-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  margin-bottom: 24px;
}

/* 模块一：头部超级轮播图 */
.carousel-wrapper {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border-radius: 12px;
  overflow: hidden;
}
.hero-carousel {
  height: 600px;
}
.hero-carousel /deep/ .el-carousel__container {
  height: 100% !important;
}
.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* 模块二：中部 */
.mid-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 20px;
  gap: 20px;
}
.mid-contact {
  flex: 1;
  min-width: 250px;
  display: flex;
  justify-content: center;
}
.contact-banner {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.contact-banner:hover {
  transform: scale(1.02);
}
.mid-customers {
  flex: 3;
  min-width: 300px;
}
.customers-carousel {
  width: 100%;
}

/* 新增：核心优势模块 */
.features-section {
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
}
.features-title {
  font-size: 28px;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: bold;
}
.features-subtitle {
  font-size: 15px;
  color: #888;
  margin: 0 0 35px 0;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
}
.feature-item {
  padding: 30px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid #f0f4f8;
}
.feature-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #409eff;
}
.feature-icon {
  font-size: 50px;
  color: #409eff;
  margin-bottom: 20px;
}
.feature-name {
  font-size: 18px;
  color: #333;
  margin: 0 0 12px 0;
}
.feature-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.customer-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f9f9f9;
  border-radius: 8px;
}
.customer-name-bar {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  box-sizing: border-box;
}
.customer-name {
  color: #fff;
  font-size: 14px;
}

/* 模块三：广告区 */
.ad-nav-box {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ad-img {
  width: 100%;
  max-width: 600px; /* 控制电脑端不要宽得离谱 */
  height: auto;
  border-radius: 8px;
  margin-bottom: 30px;
}
.nav-cloth {
  width: 100%;
}

/* 模块四：照片墙 Grid */
.photo-wall-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
.photo-wall-row:last-of-type {
  margin-bottom: 24px;
}
.photo-wall-row img {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  transition: transform 0.3s;
}
.photo-wall-row img:hover {
  transform: translateY(-4px);
}

/* 模块五：底部 Flex 布局 */
.info-section {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.info-left, .info-right {
  flex: 1;
  min-width: 300px;
  padding: 24px;
}
.section-title {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin: 0;
  font-weight: 600;
}
.news-banner {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.news-item {
  border-bottom: 1px solid #ebeef5;
}
.news-item:last-child {
  border-bottom: none;
}
.news-link {
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  text-decoration: none;
  color: #606266;
  font-size: 16px;
  transition: all 0.3s ease;
}
.news-link:hover {
  color: #409eff;
  transform: translateX(4px);
}

.about-banner {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
}
.about-desc {
  color: #606266;
  font-size: 16px;
  line-height: 1.8;
  text-align: justify;
}
.about-thumbs {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.about-thumbs img {
  flex: 1;
  width: 0; /* flex-1 hack */
  border-radius: 6px;
  object-fit: cover;
}

/* >>>>> 响应式媒体查询 <<<<< */
@media screen and (max-width: 768px) {
  .hero-carousel {
    height: 300px;
  }
  .photo-wall-row {
    grid-template-columns: 1fr;
  }
  .mid-section {
    flex-direction: column;
  }
  .mid-contact, .mid-customers {
    width: 100%;
  }
  .info-section {
    flex-direction: column;
  }
  .info-left, .info-right {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .hero-carousel {
    height: 220px;
  }
  .section-title {
    font-size: 20px;
  }
  .news-link {
    flex-direction: column;
    gap: 4px;
  }
  .news-date {
    font-size: 13px;
    color: #999;
  }
}
</style>